import * as React from 'react';

import { CardStatusTag } from '@coursera/cds-core';

import { getGenAiBadges } from 'bundles/product-card/hooks/useGenAiBadges';

import _t from 'i18n!nls/product-card';

const BADGE_NAMES = {
  FREE: 'Free',
  FREE_TRIAL: 'Free Trial',
};

export const getProductCardStatusTags = ({
  isNew,
  statusTags,
  slug,
}: {
  isNew?: boolean;
  statusTags?: string[] | null;
  slug?: string;
}) => {
  const { badges: genAiBadges, names } = getGenAiBadges(slug);
  const tags = [];
  const tagNames = [];

  if (isNew) {
    tags.push(<CardStatusTag key="new">{_t('New')}</CardStatusTag>);
    tagNames.push('New');
  }
  if (statusTags && statusTags.length > 0) {
    statusTags.forEach((statusTag) => {
      switch (statusTag) {
        case BADGE_NAMES.FREE:
          tags.push(<CardStatusTag key={statusTag}>{_t('Free')}</CardStatusTag>);
          tagNames.push('Free');
          break;
        case BADGE_NAMES.FREE_TRIAL:
          tags.push(<CardStatusTag key={statusTag}>{_t('Free Trial')}</CardStatusTag>);
          tagNames.push('Free Trial');
          break;
        default:
        // no ops
      }
    });
  }
  tags.push(...genAiBadges);
  tagNames.push(...names);

  return { tags, tagNames };
};
